import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'

export const questionList = [
  {
    id: 0,
    title: 'Quel type de couches utilisez-vous le plus?',
    note: <></>,
    answers: [
      { title: 'Des couches jetables', value: 'jetable' },
      { title: 'Des couches lavables', value: 'lavable' }
    ],
    answer: null,
    result: false,
    topic: 'diapers',
    nextQuestion: {
      answerId: 0,
      nextQuestionId: {
        jetable: 1,
        lavable: 2
      }
    }
  },
  {
    id: 1,
    title: 'Ces couches sont-elles biodégradables?',
    note: <></>,
    answers: [
      { title: 'Oui', value: 0.8 },
      { title: 'Non', value: 1 }
    ],
    answer: null,
    result: true,
    topic: 'diapers',
    nextQuestionId: 8
  },
  {
    id: 2,
    title: 'Comment lavez-vous les couches?',
    note: <></>,
    answers: [
      { title: 'Je les lave moi-même', value: 'maison' },
      {
        title: 'J’ai un abonnement à une société de lavage de couches',
        value: 'externe'
      }
    ],
    answer: null,
    result: true,
    topic: 'diapers',
    nextQuestion: {
      answerId: 2,
      nextQuestionId: {
        maison: 3,
        externe: 8
      }
    }
  },
  {
    id: 3,
    title: "Quel type d'électricitez utilisez vous?",
    note: <></>,
    answers: [
      { title: 'Renouvelable', value: -49.2 },
      { title: 'Normale', value: 0 }
    ],
    answer: null,
    result: true,
    topic: 'diapers'
  },
  {
    id: 4,
    title: 'Lavez-vous les couches dans des machines pleines?',
    note: <></>,
    answers: [
      { title: 'Oui', value: -93.5 },
      { title: 'Non', value: 0 }
    ],
    answer: null,
    result: true,
    topic: 'diapers'
  },
  {
    id: 5,
    title: 'A quelle température lavez-vous les couches?',
    note: <></>,
    answers: [
      { title: '60°', value: 0 },
      { title: '90°', value: 176.8 }
    ],
    answer: null,
    result: true,
    topic: 'diapers'
  },
  {
    id: 6,
    title: 'Comment séchez-vous les couches?',
    note: <></>,
    answers: [
      { title: 'Au sèche-linge', value: 1 },
      { title: 'A l’air-libre', value: -90.6 },
      {
        title: 'Parfois au sèche-linge (environ une fois sur quatre)',
        value: 246.2
      }
    ],
    answer: null,
    result: true,
    topic: 'diapers'
  },
  {
    id: 7,
    title:
      'Est-ce que vous avez réutilisé les couches lavables pour un deuxième enfant?',
    note: <></>,
    answers: [
      { title: 'Oui', value: -33.5 },
      { title: 'Non', value: 0 }
    ],
    answer: null,
    result: true,
    topic: 'diapers'
  },
  {
    id: 8,
    title: 'Quel type de lait donnez-vous à votre bébé?',
    note: <></>,
    answers: [
      { title: 'Du lait maternel', value: 'maternel' },
      { title: 'Du lait en poudre', value: 'poudre' },
      { title: 'Les deux', value: 'mixte' }
    ],
    answer: null,
    result: false,
    topic: 'milk',
    nextQuestion: {
      answerId: 8,
      nextQuestionId: {
        maternel: 9,
        poudre: 12,
        mixte: 9
      }
    }
  },
  {
    id: 9,
    title:
      'Durant combien de mois votre bébé a-t-il été nourri exclusivement au sein?',
    note: <></>,
    answers: [...new Array(37)].map((a, i) => ({ title: '' + i, value: i })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: false,
    topic: 'milk'
  },
  {
    id: 10,
    title:
      'Est-ce que la personne qui allaite le bébé a mangé davantage en raison de l’allaitement?',
    note: (
      <>
        Note: un apport de 500 kcal est recommandé à la personne allaitant le
        bébé durant les 6 premiers mois, selon{' '}
        <Link href='http://www.fao.org/3/y5686e/y5686e.pdf'>
          une étude de l'OMS et de l'ONU
        </Link>{' '}
        (page 65).
      </>
    ),
    answers: [
      { title: 'Oui', value: true },
      { title: 'Non', value: false }
    ],
    answer: null,
    result: false,
    topic: 'milk'
  },
  {
    id: 11,
    title: 'Est-ce que la personne qui allaite le bébé a un régime végétarien?',
    note: <></>,
    answers: [
      { title: 'Oui', value: true },
      { title: 'Non', value: false }
    ],
    answer: null,
    result: true,
    topic: 'milk',
    nextQuestion: {
      answerId: 8,
      nextQuestionId: {
        maternel: 15,
        mixte: 12
      }
    }
  },
  {
    id: 12,
    title:
      'Durant combien de mois votre bébé a-t-il été nourri exclusivement au biberon?',
    note: <></>,
    answers: [...new Array(37)].map((a, i) => ({ title: '' + i, value: i })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'milk'
  },
  {
    id: 13,
    title:
      'En moyenne, combien de kilos de lait en poudre utilisez-vous par mois?',
    note: (
      <>
        Exemple de calcul pour 4 biberons par jour contenant chacun 6 cuillères
        de 5 grammes:
        <br /> 4 * 6 * 5 * 30 = 3600 grammes = 3.6 kilos
      </>
    ),
    // de 3 à 6 kg
    answers: [1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6].map((a, i) => ({
      title: '' + a + ' kilos',
      value: a
    })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'milk',
    nextQuestion: {
      answerId: 8,
      nextQuestionId: {
        poudre: 15,
        mixte: 14
      }
    }
  },
  {
    id: 14,
    title:
      'Durant combien de mois votre bébé a-t-il été nourri à la fois au sein et au biberon?',
    note: <></>,
    answers: [...new Array(37)].map((a, i) => ({ title: '' + i, value: i })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'milk'
  },
  {
    id: 15,
    title: 'Quel type de petits pots donnez vous principalement à votre bébé?',
    note: <></>,
    answers: [
      { title: 'Fait maison', value: 'fait-maison' },
      { title: 'Industriel', value: 'industriel' }
    ],
    answer: null,
    result: true,
    topic: 'food',
    nextQuestion: {
      answerId: 15,
      nextQuestionId: {
        industriel: 16,
        'fait-maison': 17
      }
    }
  },
  {
    id: 16,
    title: 'Les pots sont-ils en verre ou en plastiques?',
    note: <></>,
    answers: [
      { title: 'En verre', value: 'verre' },
      { title: 'En plastique', value: 'plastique' }
    ],
    answer: null,
    result: true,
    topic: 'food'
  },
  {
    id: 17,
    title: 'Combien de peluches votre bébé possède-t-il actuellement ?',
    note: <></>,
    answers: [...new Array(31)].map((a, i) => ({ title: '' + i, value: i })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'teddy'
  },
  {
    id: 18,
    title: 'Combien de ces peluches contiennent des piles?',
    note: <></>,
    answers: [...new Array(31)].map((a, i) => ({ title: '' + i, value: i })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'teddy'
  },
  {
    id: 19,
    title: 'Quel volume de jouets en plastique avez-vous à peu près?',
    note: <></>,
    answers: [
      {
        title: 'L’équivalent d’une boîte à chaussure ou moins',
        value: 10
      },
      {
        title: 'Une grande caisse de rangement',
        value: 50
      },
      { title: 'La moitié d’une armoire', value: 100 },
      { title: 'Une armoire ou plus', value: 200 }
    ],
    answer: null,
    result: false,
    topic: 'toys'
  },
  {
    id: 20,
    title: 'Quel volume de jouets en bois avez-vous à peu près?',
    note: <></>,
    answers: [
      // TODO ajotuer réponse 0
      {
        title: 'L’équivalent d’une boîte à chaussure ou moins',
        value: 10
      },
      {
        title: 'Une grande caisse de rangement',
        value: 50
      },
      { title: 'La moitié d’une armoire', value: 100 },
      { title: 'Une armoire ou plus', value: 200 }
    ],
    answer: null,
    result: false,
    topic: 'toys'
  },
  {
    id: 21,
    title: 'Pour combien d’enfants ces jouets ont-ils servi en moyenne?',
    note: <></>,
    answers: [...new Array(5)].map((a, i) => ({
      title: '' + (i + 1),
      value: i + 1
    })),
    answer: null,
    label: 'Choisir...',
    noResultMessage: 'Merci de choisir l’un des nombres proposés',
    type: 'autocomplete',
    result: true,
    topic: 'toys'
  },
  {
    id: 22,
    title: 'Où achetez-vous les vêtements de votre bébé?',
    note: <></>,
    answers: [
      { title: 'En magasin', value: 0 },
      { title: 'En ligne', value: 33 },
      { title: 'Moitié moitié', value: 66 }
    ],
    answer: null,
    result: false,
    topic: 'clothes'
  },
  {
    id: 23,
    title: 'D’où viennent les vêtements de votre bébé?',
    note: <></>,
    answers: [
      { title: 'Seconde main', value: 420 },
      { title: 'Neuf', value: 810 },
      { title: 'Neuf mais de marques renouvelables', value: 0 }
    ],
    answer: null,
    result: true,
    topic: 'clothes'
  },
  {
    id: 24,
    title: 'Comment lavez-vous ces vêtements?',
    note: (
      <>
        Laver à froid (20-30°) consomme moins d’énergie mais ne tue pas
        certaines bactéries.
      </>
    ),
    answers: [
      { title: 'À l’eau froide', value: 0 },
      { title: 'À l’eau chaude', value: 15 },
      { title: 'Un peu des deux', value: 30 }
    ],
    answer: null,
    result: true,
    topic: 'clothes'
  },
  {
    id: 25,
    title: 'En général, comment séchez-vous les vêtements de votre bébé?',
    note: <></>,
    answers: [
      { title: 'A l’air libre', value: 0 },
      { title: 'Au sèche-linge', value: 246 },
      { title: 'Un peu des deux', value: 123 }
    ],
    answer: null,
    result: true,
    topic: 'clothes'
  },
  {
    id: 26,
    title: 'Comment éliminez-vous les vêtements de votre bébé?',
    note: <></>,
    answers: [
      { title: 'Je les donne ou revends', value: 0 },
      { title: 'Je les jette à la poubelle ', value: 54 },
      { title: 'Un peu des deux', value: 27 }
    ],
    answer: null,
    result: true,
    topic: 'clothes'
  }
]
